export interface B2bPricingConfig {
  isB2b: boolean;
  vatRate: number;
  country: string;
}

export function getB2bPricing(): B2bPricingConfig {
  const fromWindow = (window as Window & { b2bPricing?: B2bPricingConfig }).b2bPricing;
  if (fromWindow) {
    return fromWindow;
  }

  const root = document.documentElement;
  return {
    isB2b: root.dataset.isB2b === 'true',
    vatRate: parseFloat(root.dataset.b2bVatRate || '1') || 1,
    country: (window as Window & { Shopify?: { country?: string } }).Shopify?.country || '',
  };
}

export function adjustPriceCents(cents: number): number {
  const { isB2b, vatRate } = getB2bPricing();
  if (!isB2b || vatRate <= 0) {
    return cents;
  }

  return Math.floor(cents / vatRate);
}

export function formatPrice(cents: number, format?: string): string {
  const adjustedCents = adjustPriceCents(cents);
  const { country } = getB2bPricing();
  const formatted = window.Shopify.formatMoney(adjustedCents, format);

  if (country === 'SE') {
    return formatted.replace('.00', '').replace(/,/g, ' ');
  }

  return formatted;
}

export function formatPriceEur(cents: number): string {
  const adjustedCents = adjustPriceCents(cents);
  return window.Shopify.formatMoney(adjustedCents, '{{amount}} €')
    .replace(/,/g, ' ')
    .replace(/\./g, ',')
    .replace(/,00/, '');
}

export function formatPriceSek(cents: number): string {
  const adjustedCents = adjustPriceCents(cents);
  return window.Shopify.formatMoney(adjustedCents, '{{amount_no_decimals}} kr').replace(/,/g, ' ');
}

/** Format cents that are already B2B-adjusted (e.g. from Liquid data-*-price-cents attributes). */
export function formatDisplayCents(cents: number, format?: string): string {
  const { country } = getB2bPricing();
  const formatted = window.Shopify.formatMoney(cents, format);

  if (country === 'SE') {
    return formatted.replace('.00', '').replace(/,/g, ' ');
  }

  return formatted;
}
